import { Box, Button } from '@material-ui/core';

import { Panel, Typography } from '@components';
import { DeploymentsGrid } from '@views';
import { content, page } from '@content';

import { IN_DEVELOPMENT_LIMIT, IN_MARKET_LIMIT } from './TopDeployments.const';
import { TopDeploymentsProps } from './TopDeployments.props';
import { useStyles } from './TopDeployments.styles';

export const TopDeployments = ({
  className = '',
  businessUnitId,
  inDevelopment,
  inMarket,
  onViewAll,
}: TopDeploymentsProps): JSX.Element => {
  const styles = useStyles();

  return (
    <Panel className={`${styles.topDeployments} ${className}`}>
      <Box className={styles.head}>
        <Typography.Title>{content.deployment}</Typography.Title>
        <Button className={styles.viewAll} variant="contained" color="secondary" onClick={onViewAll}>
          {content.viewAll}
        </Button>
      </Box>
      <Box className={styles.body}>
        <DeploymentsGrid
          className={styles.inDevelopment}
          linkTo={`${page.experienceBuilder}?businessUnit=${businessUnitId}`}
          title={content.inDevelopment}
          items={inDevelopment.slice(0, IN_DEVELOPMENT_LIMIT)}
        />
        <DeploymentsGrid
          className={styles.inMarket}
          linkTo={`${page.analytics}${page.modulePerformanceByPosition}?businessUnit=${businessUnitId}`}
          title={content.inMarket}
          items={inMarket.slice(0, IN_MARKET_LIMIT)}
          bordered
          wide
        />
      </Box>
    </Panel>
  );
};
